<script lang="ts" setup>
  import { Text } from '@bt/design-system'
  import renderRichText from '~/utils/renderSbRichText'
  import { pushToDataLayer } from '@/utils/dataLayer'
  import { useDataLayerHelpers } from '@/composables/data-layers/useDataLayerHelpers'

  interface IIcon {
    filename: string
    alt?: string
    title?: string
  }
  interface IContact {
    title: string
    icon?: IIcon
    content: string
  }

  withDefaults(
    defineProps<{
      blok: IContact
      isLastElement?: boolean
    }>(),
    {
      isLastElement: false
    }
  )

  const { locale } = useI18n()
  const dataLayerHelpers = useDataLayerHelpers()

  const onEmailClick = (e: MouseEvent) => {
    const targetElement = e.target
    if (targetElement instanceof HTMLAnchorElement) {
      const hrefValue = targetElement?.href

      if (hrefValue?.startsWith('mailto:')) {
        const email = hrefValue.split('mailto:')[1]

        pushToDataLayer({
          event: 'contact_events',
          event_category: 'email_clicks',
          page_type: dataLayerHelpers.getPageType(),
          event_label: email,
          site_language: locale.value
        })
      }
    }
  }
</script>

<template>
  <div
    class="contact-row flex items-center gap-8"
    :class="{ 'mb-8': !isLastElement }"
  >
    <div class="flex items-center gap-2">
      <NuxtImg
        v-if="blok.icon"
        :src="blok.icon?.filename"
        :alt="blok.icon?.alt ?? ''"
        :title="blok.icon?.title ?? ''"
        width="24"
        height="24"
      />
      <span class="flex-shrink-0 font-medium">{{ blok.title }}</span>
    </div>
    <Text
      :text="renderRichText(blok.content)"
      tag="span"
      type="body1"
      class="break-all"
      @click="onEmailClick($event)"
    />
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/styles/common.scss';

  .contact-row {
    :deep {
      img {
        width: rem(24);
      }
    }
  }
</style>
